import styled from "styled-components/macro";
import { space, boxShadow, color } from "styled-system";
import forwardProps, { removePropTypes } from "../utils/forwardProps";

export const Section = styled(
  forwardProps(removePropTypes(space, color))("section")
)(space, color);
Section.defaultProps = { pt: 3, pb: 3 };

export const Shadow = styled.div(boxShadow, { position: "relative" });
Shadow.defaultProps = { boxShadow: "md" };
